import React from "react";
import {
    Dimensions,
    FlatList,
    StyleSheet,
    Text,
    TouchableOpacity,
    View
} from "react-native";

import {
  getFocusEntity, setFocusEntity, setNotifyEntity, getOneEntity
} from "../../API/API";
import {
    BriefingTab, NetworkTab, EntityTab, ThemeTab
} from "./SharedProfileTab"
import MailPicto from "../Picto/MailPicto";
import AdressePicto from "../Picto/AdressePicto";
import PhonePicto from "../Picto/PhonePicto";
import RichText from "../Shared/RichText";


const getDimensions = () => Dimensions.get('window');

class EntityProfile {
  load(id) {
    return getOneEntity(id).then(item => {
      return getFocusEntity().then(data => {
	const focus = data[id] || {focus_enabled: false, notification_enabled: false};
	return {
	  item,
	  focus_enabled: focus.focus_enabled,
	  notification_enabled: focus.notification_enabled
	}
      });
    })
  }
  setFocus(item, focus_enabled) {
    const action = focus_enabled ? 'unset' : 'set'
    return setFocusEntity(item.id, action).then(() => !focus_enabled)
  }
  setNotification(item, notification_enabled) {
    const action = notification_enabled ? 'unset' : 'set'
    return setNotifyEntity(item.id, action).then(() => !notification_enabled)
  }
  getInfo(item) {
    return {
      title: item.name,
      subtitle: item.label,
      description: item.description,
      affiliations: item.affiliations,
    }
  }
  getTab(props) {
    return [{
	title : 'Briefing',
	content : this._getBriefing(props),
      }, {
	title : 'Profil',
	content : this._getProfil(props),
      }, {
	title : 'Coordonnées',
	content : this._getCoordonnees(props),
      }, {
	title : 'Réseaux',
	content : this._getReseau(props),
      }, {
	title : 'Entités',
	content : this._getEntity(props),
      }, {
	title : 'Themes',
	content : this._getTheme(props),
      }
    ]
  }
  _getBriefing(props) {
    const {navigation, route, item, type} = props;
    return <BriefingTab navigation={navigation} route={route} item={item} type={type} />
  }
  _getReseau(props) {
    const { item, type, navigation } = props;
    return <NetworkTab navigation={navigation} item={item} type={type} />
  }
  _getEntity(props) {
    const {navigation, item, type} = props;
    return <EntityTab navigation={navigation} item={item} type={type} />
  }
  _getTheme(props) {
    const {navigation, t, item, all_themes} = props;
    return <ThemeTab navigation={navigation} t={t} item={item} all_themes={all_themes} />
  }
  _getCoordonnees(props){
    const { item, theme } = props;
    const { width, height } = getDimensions();

    const styles = StyleSheet.create({
      itemContainer: {
	height: 60,
	//width: "99%",
	backgroundColor: theme.colors.primary.White.value,
	borderRadius: 10,
	paddingVertical: 18,
	paddingHorizontal: 20,
	flexDirection: "row",
	alignItems: "center",
	marginHorizontal: 10,
	marginVertical: 5
      },
      itemText: {
	fontFamily: theme.fonts.text,
	colors: theme.colors.primary.blue1.value,
	fontSize: 15,
	marginLeft: 5
      }
    });

    const infos = [
	{picto : <AdressePicto isHeader={true} style={{height:20}} />,text: (item.address===null || item.address)? null : item.address + " "+ item.country ,onPress:()=>{}},
	{picto : <MailPicto isHeader={true} style={{height:20}} />,text: item.email,onPress:()=>{}},
	{picto : <PhonePicto isHeader={true} style={{height:20}}/>,text: item.phone,onPress:()=>{}},
    ].filter(item => item.text);

    const renderitem = ({item}) => {
      return <TouchableOpacity onPress={item.onPress}>
	<View style={styles.itemContainer}>
	    {item.picto}
	    <Text style={styles.itemText}>{item.text}</Text>
	</View>
      </TouchableOpacity>
    }
    return (
	<FlatList style={{width:width,marginTop:20}} data={infos} renderItem={renderitem} />
    );
  }
  _getProfil(props) {
    const { width } = getDimensions();
    const { theme, t, item } = props;

    const styles = StyleSheet.create({
      container: {
	backgroundColor: theme.colors.primary.White.value,
	width: width-20,
	padding: 20,
	margin: 10,
	borderRadius: 10
      } ,
      title: {
	fontFamily: theme.fonts.title,
	fontWeight: "600",
	color: theme.colors.tertiary.black1.value,
	fontSize: 17
      } ,
      text: {
	fontFamily: theme.fonts.text,
	color: theme.colors.tertiary.black1.value,
	fontSize: 15
      }
    });

    return <View style={styles.container}>
      <Text style={styles.title}>{t('Description')}</Text>
      <Text style={styles.text}><RichText text={item.description} /></Text>
    </View>
  }
}

export default EntityProfile;
